module.exports = __webpack_public_path__ + "static/media/Profile.5818fc09.svg";